import { render, staticRenderFns } from "./Dobavljac.vue?vue&type=template&id=56e82f15&scoped=true&"
import script from "./Dobavljac.vue?vue&type=script&lang=js&"
export * from "./Dobavljac.vue?vue&type=script&lang=js&"
import style0 from "./Dobavljac.vue?vue&type=style&index=0&id=56e82f15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e82f15",
  null
  
)

export default component.exports